import React from 'react';
import PropTypes from 'prop-types';
import { graphql, createFragmentContainer } from 'react-relay';

// components
import { FormattedMessage } from 'react-intl';
import { PdpSharedMakerHeadshotModule } from './PdpSharedMakerHeadshotModule/PdpSharedMakerHeadshotModule';
import { ExpandingAreaWithReadMore } from 'dibs-elements/exports/ExpandingArea';

// styles
import styles from './PdpSharedDescription.scss';

// helpers
import get from 'lodash.get';
import classNames from 'classnames';

export const Title = () => (
    <FormattedMessage
        id="PdpSharedDescriptionAboutMaker.aboutMakerHeader"
        defaultMessage="About The Maker"
    />
);

export const Content = ({ contentClass, seller, liveStorefront }) => (
    <React.Fragment>
        <PdpSharedMakerHeadshotModule seller={seller} />
        <ExpandingAreaWithReadMore collapsedHeight={144}>
            <span className={classNames(styles.content, contentClass)}>
                {liveStorefront.aboutUs}
            </span>
        </ExpandingAreaWithReadMore>
    </React.Fragment>
);

Content.propTypes = {
    contentClass: PropTypes.string,
    seller: PropTypes.object,
    liveStorefront: PropTypes.object,
};

function PdpSharedDescriptionAboutMakerComponent(props) {
    const { headerClass, contentClass, item } = props;
    const liveStorefront = get(item, 'seller.liveStorefrontProfile') || {};

    if (!liveStorefront.aboutUs || !get(item, 'seller.isMakerOrManufacturer')) {
        return null;
    }

    return (
        <div data-tn="pdp-item-description-about-maker" className={styles.wrapper}>
            <h2 className={classNames(styles.header, headerClass)}>
                <Title />
            </h2>
            <Content
                contentClass={contentClass}
                seller={item.seller}
                liveStorefront={liveStorefront}
            />
        </div>
    );
}

PdpSharedDescriptionAboutMakerComponent.propTypes = {
    contentClass: PropTypes.string,
    headerClass: PropTypes.string,
    item: PropTypes.object.isRequired,
};

export const PdpSharedDescriptionAboutMaker = createFragmentContainer(
    PdpSharedDescriptionAboutMakerComponent,
    {
        item: graphql`
            fragment PdpSharedDescriptionAboutMaker_item on Item {
                seller {
                    isMakerOrManufacturer
                    sellerProfile {
                        company
                    }
                    sellerPreferences {
                        urlLabel
                    }
                    liveStorefrontProfile {
                        aboutUs
                        photos {
                            path
                            type {
                                name
                            }
                        }
                    }
                    ...PdpSharedMakerHeadshotModule_seller
                }
            }
        `,
    }
);
